import { createAction } from 'redux-actions'

export const setOrderInfo = createAction('SET_ORDER_INFO')
export const clearOrderInfo = createAction('CLEAR_ORDER_INFO')
export const clearTicketingOrder = createAction('CLEAR_TICKETING_ORDER')